if (!customElements.get('color-swatch')) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.processSwatch();
    }

    hexToRgb(hex) {
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((x) => x + x)
          .join('');
      }
      const num = parseInt(hex, 16);
      return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
    }

    highContrastColor(hexColor) {
      if (!hexColor) return null;
      return (([r, g, b]) => (r * 299 + g * 587 + b * 114) / 1000 > 155)(
        this.hexToRgb(hexColor)
      );
    }

    lowContrastColor = (hexColor) => {
      if (!hexColor) return null;

      return (([r, g, b]) => 0.2126 * r + 0.7152 * g + 0.0722 * b < 40)(
        this.hexToRgb(hexColor)
      );
    };

    processSwatch() {
      const swatchColor = this.dataset.colorSwatch?.trim();
      const lightClass = this.dataset.colorLightClass
        ?.split(/\s+/)
        .filter(Boolean);
      const darkClass = this.dataset.colorDarkClass?.split(/\s+/).filter(Boolean);

      if (swatchColor && this.highContrastColor(swatchColor)) {
        this.classList.add(...lightClass);
      }

      if (swatchColor && this.lowContrastColor(swatchColor)) {
        this.classList.add(...darkClass);
      }
    }
  }

  customElements.define('color-swatch', ColorSwatch);
}
